import { BaseContainerModel } from "../../base-container.model";
import { bl_fi_cash_document_temp_queue_RowClass  } from "../../../dbschema";

export class CashDocumentTempQueueContainer extends BaseContainerModel {
    bl_fi_cash_document_temp_queue: bl_fi_cash_document_temp_queue_RowClass = new bl_fi_cash_document_temp_queue_RowClass();
}
